export const OfferListMessages = {
  title: {
    id: 'Pages.Consumer.Post.Submission.Offers.View.Title',
    description: 'Offer page title',
  },
}
